import Header from '../Header/Header';
import { CustomTable, ConfirmationPopup, SuccessModal, Pagination, Search, Loader } from '@ohif/ui';
import React, { useState, useEffect } from 'react'
// import './index.css'
import { useNavigate } from 'react-router-dom';
import { DELETEHOSPITAL, GETHOSPITALLIST } from '../Apis/apis';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _hospitalUrls, _pacsUrls } from '@custom/Utils/constants/apiUrls';
import { customStyle } from '@custom/Utils/utils';
import {useTheme} from "../../ui/src/contextProviders"
import { localKcDcmTokenApi } from '@custom/rtk-apis/authentication/local-kc-dcm-token';
import { KC_GRANT_TYPE } from '@custom/constant';
import { AppDispatch,RootState } from '../store/store';
import { useDispatch, useSelector } from 'react-redux';
import { clearLocalKcDcmTokenState } from '@custom/store/slices/authentication/local-kc-dcm-token';
import { savePACSToSessionStorage } from '@custom/Utils/localPACSutils';
import { servicesManager } from '../../app/src/App';
const Pacs = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const localKcDcmTokenResponse = useSelector((state: RootState) => state.localKcDcmTokenResponse);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isChangePACSPopupOpen, setIsChangePACSPopupOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModal] = useState(false);
  const [IsPACSChangeSuccessModal,setIsPACSChangeSuccessModal] = useState(false);
  const [errorMessage,setErrorMessage]=useState("")
  const [selectedRow, setSelectedRow] = useState(null);
 const [tokenRetrieved,setTokenRetrieved] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [tableData, setTableData] = useState([])
  const [search, setSearch] = useState('');
  const [pgNumber, setPgNumber] = useState(1);
  const [pgLimit, setPgLimit] = useState(30);
  const [totalPg, setTotalPg] = useState(1000000);
  const [load, setLoad] = useState(true);
  const [pacsChangeLoading,setPacsChangeLoading] = useState(false)
  const [searchInputValue, setSearchInputValue] = useState('');
  const { uiNotificationService } = servicesManager.services

  useEffect(() => {
    if(localKcDcmTokenResponse.status === 'ERROR'){
      setPacsChangeLoading(false)
      uiNotificationService.show({
        title: "Error",
        type: "error",
        message: "Something went wrong! Please check PACS credentials!",
        position: "bottomRight"
      })
    }
  }, [localKcDcmTokenResponse]);

  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const clearSearch = () => {
    setSearchQuery('');
  };
  const onPageChangeHandler = pg => {
    //callReportsAPI(pgLimit, pg);

    setPgNumber(pg);
    getAllPacsList(search, pgLimit, pgNumber)
  };
  const handlePageSizeChange = e => {
    //callReportsAPI(e, pgNumber);
    setPgLimit(e);
    getAllPacsList(search, pgLimit, pgNumber)
  };
  const columns = [
    { key: 'aeTitle', title: 'AE Title', sort: true },
    { key: 'localPacsAddress', title: 'PACS Address' },
    { key: 'actions', title: 'Action' }
  ];
  const actions = [
    {
      id: 'editPacs',
      label: 'Edit',
      iconName: 'edit',
      onClick: ((item) => {
        navigate("/addpacs", {
          state: {
            pacsData: item
          }
        })
      })
    },
    {
      id:'deletePacs',
      label: 'Delete',
      iconName: 'delete',
      onClick: ((item) => {
        setSelectedRow(item);
        setIsPopupOpen(true)
      })
    },
    {
      id:'togglePacs',
      label: 'Toggle',
      iconName: 'toggle',
      onChange: ((item) => {
        setSelectedRow(item);
        setIsChangePACSPopupOpen(true);
      })
    }
  ];
  const handlePACSChangeConfirm = async () => {
    try {
      setPacsChangeLoading(true);
      setIsChangePACSPopupOpen(false);
      console.log('Selected Row:', selectedRow);

      // Step 1: Get the token if the PACS is being activated
      if (selectedRow?.active === false) {
        const localParams = new URLSearchParams();
        localParams.append('client_id', selectedRow.kcClientId);
        localParams.append('client_secret', selectedRow.kcClientSecret);
        localParams.append('grant_type', KC_GRANT_TYPE);
        localParams.append('kc_url', selectedRow.kcURL);

        const tokenResponse = await dispatch(localKcDcmTokenApi(localParams)).unwrap();
        console.log('Token Response:', tokenResponse);

        // Extract the token from the response
        const token = tokenResponse?.access_token || tokenResponse?.result?.access_token;
        if (!token) {
          console.error('Error in LOCAL PACS authentication: No access token received.');
          setErrorMessage('LOCAL PACS token error');
          setPacsChangeLoading(false);
          return; // Exit the function if token retrieval fails
        }

        // Store the token based on rememberMe status
        const rememberMe = inferRememberMe();
        if (rememberMe) {
          localStorage.setItem('local_pacs_access_token', token);
        } else {
          sessionStorage.setItem('local_pacs_access_token', token);
        }
        dispatch(clearLocalKcDcmTokenState());
        // Set a state to indicate that the token has been successfully retrieved
        setTokenRetrieved(true);
      } else {
        // If PACS is being deactivated, proceed directly to the database update
        setTokenRetrieved(true);
      }
    } catch (error) {
      console.error('Error in handlePACSChangeConfirm:', error);
      setErrorMessage('An error occurred while processing your request.');
    }
  };

  // Use useEffect to handle the database update after the token is retrieved
  useEffect(() => {
    if (tokenRetrieved) {
      const updateDatabase = async () => {
        try {
          const response = await apiRequest({
            method: 'POST',
            endUrl: _pacsUrls.updateActivePACSDetail,
            headerType: 'json',
            body: {
              id: selectedRow?._id,
              active: selectedRow?.active === true ? false : true,
            },
          });

          if (response.status) {
            // Update the local state to reflect the new active status
            let LocalPacsInfo = selectedRow;
            LocalPacsInfo.active = selectedRow?.active === true ? false : true;

            if (LocalPacsInfo.active === false) {
              localStorage.removeItem('local_pacs_access_token');
              sessionStorage.removeItem('local_pacs_access_token');
              savePACSToSessionStorage('LOCAL_PACS_INFO', []);
            }
            if (LocalPacsInfo.active === true) {
              const { kcClientId, kcClientSecret, kcURL, ...sanitizedPACS } = LocalPacsInfo;
              const sanitizedPACSInfo = [sanitizedPACS];
              savePACSToSessionStorage('LOCAL_PACS_INFO', sanitizedPACSInfo);
            }
            await getAllPacsList(search, pgLimit, pgNumber);
            setPacsChangeLoading(false);
            setIsPACSChangeSuccessModal(true);
          }
        } catch (error) {
          console.error('Error updating database:', error);
          setErrorMessage('An error occurred while updating the database.');
          setPacsChangeLoading(false);
        } finally {
          // Reset the tokenRetrieved state after the database update
          setTokenRetrieved(false);
          setPacsChangeLoading(false);
        }
      };

      updateDatabase().then(() => {;
      window.location.reload();})
    }
  }, [tokenRetrieved]);

  const inferRememberMe = () => {
    const tokenInLocalStorage = localStorage.getItem('token');
    const tokenInSessionStorage = sessionStorage.getItem('token');
    if ( tokenInLocalStorage) {
      return true;
    } else if (tokenInSessionStorage) {
      return false;
    } else {
      console.log('Remember Me status could not be determined');
      return null; // Indicates that the status is unknown
    }
  };

  const handleConfirm = async () => {
    try {
      setIsPopupOpen(false);
      const response = await apiRequest({ method: 'DELETE', endUrl: _pacsUrls.delete, headerType: 'json', body: { _id: selectedRow?._id } })
      if (response.status) {
        setIsSuccessModal(true)
        getAllPacsList(search, pgLimit, pgNumber)
      }
    }
    catch (error) {
      console.log(error)
    }
  };
  const handleChangePACSCancel = () => {
    setIsChangePACSPopupOpen(false);
  }
  const handleCancel = () => {
    setIsPopupOpen(false);
  };
  const navigateToPage = () => {
    navigate("/addpacs")
  }
  useEffect(() => {
    getAllPacsList(search, pgLimit, pgNumber)
  }, [])
  const getAllPacsList = async (search, limit, number) => {
    const pageNumber = pgLimit * (pgNumber - 1) != 0 ? pgLimit * (pgNumber - 1) : 1

    let response: any = await apiRequest({
      method: 'POST',
      endUrl: _pacsUrls.get,
      headerType: 'json',
      body: {
        search: search,
        limit: limit,
        pageNumber: pageNumber
      }
    })
    if (response?.status) {
      let tempArray = []
      setTotalPg(response?.result?.count);

      response?.result?.list?.map((item) => {
        tempArray.push({
          '_id': item._id || '--',
          "aeTitle": item.aeTitle || '--',
          "localPacsAddress": item.localPacsAddress || '--',
          "status": item.status || '--',
          "active": item.active,
          "kcClientId": item.kcClientId || '--',
          "kcClientSecret": item.kcClientSecret || '--',
          "kcURL": item.kcURL || '--',
          "hospitalId": item.hospitalId,
          "_rev": item._rev,
          "type": item.type
        })
      })
      setTableData(tempArray)
      setLoad(false)

    }

  }


  const searchClick = searchText => {
    setSearch(searchText);
    setSearchInputValue(searchText);
    getAllPacsList(searchText, pgLimit, pgNumber);
  }

  const isDarkMode = useTheme();
  return (
    <>
      <div className='page page__fullBody' style={
      isDarkMode?.isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
    }>
        <Header isBack={false} title='PACS'></Header>
        <div className='page__body'>
          <div className='tableWrap'>
            <div className='tableWrap__head'>
              <div className="formRow formRow__3 m_0 w_100 formRow--flexEnd">
                <div className='formCol'>
                  <Search text="Search by AE Title" onSearchClick={searchClick} value={searchInputValue} setValue={setSearchInputValue}></Search>
                </div>

              </div>
              {/* {tableData.length === 0 && */}
                <div className='btn__group'>
                  <button className="btn btn__white" onClick={navigateToPage}>
                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.63509 1.16699V12.8337M1.80176 7.00033H13.4684" stroke="#150823" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Add PACS</button>
                </div>
              {/* } */}
            </div>
            <div className='tableContainer'>
              <CustomTable columns={columns} data={tableData} actions={actions} searchQuery={searchQuery} from={'pacs'} />
            </div>
          </div>
        </div>
        {/* <div className='flex justify-between mt-8 mx-8 mb-8'>
        <div className="relative w-72" style={{ minWidth: '370px' }}>
          <Search text="Search by PACS Name" onSearchClick={searchClick}></Search>
        </div>
        <button className='button border border-black px-4 py-1 rounded h-10 custom-button' onClick={navigateToPage}> + Add PACS</button>
      </div>
      <div className='mx-8'>
      {load ? <Loader isLoaderOpen={load} />:<CustomTable columns={columns} data={tableData} actions={actions} searchQuery={searchQuery} from={'pacs'} />}
        {tableData.length > 0 && <Pagination
          onChangePage={onPageChangeHandler}
          onChangePerPage={handlePageSizeChange}
          totalPage={totalPg}
          currentPage={pgNumber}
          perPage={pgLimit}
        />}
      </div> */}
        {tableData.length > 0 && <Pagination
          onChangePage={onPageChangeHandler}
          onChangePerPage={handlePageSizeChange}
          totalPage={totalPg}
          currentPage={pgNumber}
          perPage={pgLimit}
        />}
        <Loader isLoaderOpen={load || pacsChangeLoading} />
        <ConfirmationPopup
          title={''}
          isOpen={isPopupOpen}
          message={`Are you sure you want to delete ${selectedRow?.aeTitle}?`}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
         <ConfirmationPopup
          title={''}
          isOpen={isChangePACSPopupOpen}
          message={`Are you sure you want to change PACS ${selectedRow?.aeTitle} status?`}
          onConfirm={handlePACSChangeConfirm}
          onCancel={handleChangePACSCancel}
        />
        <SuccessModal
          isSuccessModalOpen={isSuccessModalOpen}
          title={`PACS deleted successfully.`}
          handleCloseModal={() => setIsSuccessModal(false)}

        />
        <SuccessModal
          isSuccessModalOpen={IsPACSChangeSuccessModal}
          title={`PACS changed successfully.`}
          handleCloseModal={() => setIsPACSChangeSuccessModal(false)}

        />
      </div>
    </>
  )
}

export default Pacs
